module.exports = __webpack_public_path__ + "media/images/notifications-da8e687107167532da9fd19f9789f967.svg";